export default __webpack_public_path__ + "static/media/ic_busd_24.c5fd4433.svg";